import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { RoundingRule } from "@shared/schema";

const ROUNDING_RULE_OPTIONS = [
  { value: RoundingRule.NONE, label: "No Rounding" },
  { value: RoundingRule.NEAREST_TEN, label: "Nearest $10" },
  { value: RoundingRule.NEAREST_HUNDRED, label: "Nearest $100" },
  { value: RoundingRule.NEAREST_THOUSAND, label: "Nearest $1,000" },
  { value: RoundingRule.NEAREST_TEN_THOUSAND, label: "Nearest $10,000" },
  { value: RoundingRule.ROUND_UP_THOUSAND, label: "Round Up to $1,000" },
  { value: RoundingRule.ROUND_DOWN_THOUSAND, label: "Round Down to $1,000" },
  { value: RoundingRule.ROUND_UP_TEN_THOUSAND, label: "Round Up to $10,000" },
  { value: RoundingRule.ROUND_DOWN_TEN_THOUSAND, label: "Round Down to $10,000" },
  { value: RoundingRule.CUSTOM, label: "Custom Amount" },
];

interface RoundingTabProps {
  formData: Record<string, any>;
  updateField: (field: string, value: any) => void;
  planType: string;
}

export function RoundingTab({ formData, updateField }: RoundingTabProps) {
  const isCustom = formData.roundingRule === RoundingRule.CUSTOM;

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="roundingRule">Rounding Method</Label>
        <Select
          value={formData.roundingRule || "none"}
          onValueChange={(value) => {
            updateField("roundingRule", value);
            if (value !== RoundingRule.CUSTOM) {
              updateField("roundToNearest", "");
            }
          }}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {ROUNDING_RULE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {isCustom && (
        <div>
          <Label htmlFor="roundToNearest">Custom Rounding Amount ($)</Label>
          <Input
            id="roundToNearest"
            type="number"
            step="1"
            min="1"
            value={formData.roundToNearest || ""}
            onChange={(e) => updateField("roundToNearest", e.target.value)}
            placeholder="e.g. 250"
          />
        </div>
      )}

      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="roundGuaranteedIssue"
            checked={formData.roundGuaranteedIssue || false}
            onCheckedChange={(checked) => updateField("roundGuaranteedIssue", checked)}
          />
          <Label htmlFor="roundGuaranteedIssue" className="cursor-pointer">
            Round Guaranteed Issue Amounts
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="roundAgeReduction"
            checked={formData.roundAgeReduction || false}
            onCheckedChange={(checked) => updateField("roundAgeReduction", checked)}
          />
          <Label htmlFor="roundAgeReduction" className="cursor-pointer">
            Round Age-Reduced Amounts
          </Label>
        </div>
      </div>
    </div>
  );
}
